/**
 * Category Slider – Swiper init and tab switching.
 * Each tab has its own Swiper; nav buttons control the active one.
 */

import Swiper from 'swiper';
import 'swiper/css';

function initBlock(block) {
  const blockId = block.dataset.blockId;
  if (!blockId) return;

  const tabs = block.querySelectorAll('[role="tab"]');
  const panels = block.querySelectorAll('.category-slider__panel');
  const prevBtn = block.querySelector('.category-slider__nav-btn--prev');
  const nextBtn = block.querySelector('.category-slider__nav-btn--next');

  if (!tabs.length || !panels.length) return;

  const swiperInstances = [];
  let activeIndex = 0;

  function setActiveTab(index) {
    if (index < 0 || index >= tabs.length) return;
    activeIndex = index;

    tabs.forEach((tab, i) => {
      const isActive = i === index;
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.classList.toggle('category-slider__tab--active', isActive);
      tab.classList.toggle('category-slider__tab--inactive', !isActive);

      const indicator = tab.querySelector('.category-slider__tab-indicator');
      if (indicator) {
        indicator.style.display = isActive ? '' : 'none';
      }
    });

    panels.forEach((panel, i) => {
      const isActive = i === index;
      panel.classList.toggle('category-slider__panel--active', isActive);
      panel.hidden = !isActive;
    });
  }

  function goPrev() {
    const swiper = swiperInstances[activeIndex];
    if (swiper && typeof swiper.slidePrev === 'function') swiper.slidePrev();
  }

  function goNext() {
    const swiper = swiperInstances[activeIndex];
    if (swiper && typeof swiper.slideNext === 'function') swiper.slideNext();
  }

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => setActiveTab(index));
  });

  if (prevBtn) prevBtn.addEventListener('click', goPrev);
  if (nextBtn) nextBtn.addEventListener('click', goNext);

  block.querySelectorAll('.category-slider__swiper').forEach((el) => {
    const tabIndex = parseInt(el.dataset.swiperTab, 10);
    if (Number.isNaN(tabIndex)) return;
    const swiper = new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      loop: true,
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
      },
    });
    swiperInstances[tabIndex] = swiper;
  });

  setActiveTab(0);
}

function init() {
  document.querySelectorAll(`.wp-block-acf-category-slider[data-block-id]`).forEach(initBlock);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
